import { useEffect, useState } from "react";

import PropTypes from "prop-types";


import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";
import { ProductCategoryFormDialog } from "../product-category-form-dialog";

import { Button } from "@mui/material";

export const EditProductCategoryFormDialog = ({
  onClose,
  productCategoryId,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchProductCategory = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: {
              name,
              parent: parentProductCategory,
              lft,
              rgt,
              type,
              status,
              accountingActionChartOfAccounts,
            },
          },
        } = await apiClient.get(`product-categories/${productCategoryId}`, {
          params: {
            withParent: true,
            withAccountingActionChartOfAccounts: true,
          },
        });

        const shouldHaveParent =
          Boolean(parentProductCategory && parentProductCategory.parentId !== null);

        setDefaultValues({
          name,
          hasParent: shouldHaveParent,
          parentProductCategory: shouldHaveParent
            ? parentProductCategory
            : null,
          lft,
          rgt,
          type,
          status,
          accountingActionChartOfAccounts: Object.fromEntries(
            (accountingActionChartOfAccounts ?? [])
              .filter((item) => item.chartOfAccount)
              .map((item) => [item.action, item.chartOfAccount]),
          ),
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchProductCategory();
  }, [productCategoryId]);

  const handleSubmit = async ({
    name,
    parentId,
    type,
    status,
    accountingActionChartOfAccounts,
  }) => {
    try {
      await apiClient.put(`product-categories/${productCategoryId}`, {
        name,
        parentId,
        type,
        status,
        accountingActionChartOfAccounts,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memperbarui kategori produk"));

      throw error;
    }
  };

  return (
    <ProductCategoryFormDialog
      isOpen
      onClose={onClose}
      dialogTitle="Ubah Kategori Produk"
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Simpan
        </Button>
      )}
    />
  );
};

EditProductCategoryFormDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
  productCategoryId: PropTypes.string,
};
